import React from 'react';

import {CssBaseline} from '@mui/material';
import {ThemeProvider} from '@mui/material/styles';
import {QueryClient, QueryClientProvider} from 'react-query';
import {ReactQueryDevtools} from 'react-query/devtools';

import {AuthProvider, CsrfTokenProvider} from '@wheeebo/polaris-api';
import {SnackbarProvider} from '@wheeebo/polaris-snackbar';
import {ColorModeProvider, useColorMode, DefaultTheme, DarkTheme, PageMenuDrawerProvider} from '@wheeebo/polaris-ui';

import Navigator from '@components/Navigator';
import {IntlProviderWrapper} from './i18n';

function InnerApp(): JSX.Element {
  const {isThemeDark} = useColorMode();
  const theme = isThemeDark ? DarkTheme : DefaultTheme;
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider>
        <Navigator />
      </SnackbarProvider>
      {process.env.NODE_ENV === 'development' ? <ReactQueryDevtools /> : null}
    </ThemeProvider>
  );
}

function App(): JSX.Element {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
      },
    },
  });
  return (
    <IntlProviderWrapper>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <CsrfTokenProvider>
            <ColorModeProvider>
              <PageMenuDrawerProvider>
                <InnerApp />
              </PageMenuDrawerProvider>
            </ColorModeProvider>
          </CsrfTokenProvider>
        </AuthProvider>
      </QueryClientProvider>
    </IntlProviderWrapper>
  );
}

export default App;
